module.exports = __webpack_public_path__ + "img/bg1.ca2d0c18.jpg";